module.exports = __webpack_public_path__ + "static/img/logo-light-icon.6fe73a0.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/images/logo-light-icon.png
// module id = 16
// module chunks = 13